/**
 * Eshop class - třída s funkcemi pro kartu vozu
 */
var Eshop = window.Eshop = function () {
}

Eshop.prototype.init = function () {
    this.stickyCartCarDetail();
    this.initCheckboxShowContent();
    this.setAdditionalService();
    this.initShowHidePassword();
    this.initChangeContentSelect();
    this.initRemoveFromGarageBtn();
    this.initCheckInstallment();
    this.initTimeoutRedirect();
    this.initEnadblAjaxPaginator();

    if ($('.initInstallmentCalculatorEshop').length) {
        window.installmentCalculatorEshop = new InstallmentCalculatorEshop();
        window.installmentCalculatorEshop.init();
    }
}

Eshop.prototype.reload = function () {
    this.initStickyCartCarDetail();
    this.initEnadblAjaxPaginator();
}

Eshop.prototype.initEnadblAjaxPaginator = function () {
    if ($('.pagination').length) {
        var search = new Search();
        search.enadblAjaxPaginator();
    }
}

Eshop.prototype.initTimeoutRedirect = function () {
    var count = 3;

    var timeoutEl = $('#timeout-redirect');
    if (timeoutEl.length) {
        timeoutEl.find('span').html(count);
        setInterval(function () {
            count -= 1;
            if (count > -1) {
                timeoutEl.find('span').html(count);
            }
        }, 1000);
        setTimeout(function () {
            window.location = timeoutEl.find('a').attr('href');
        }, 3000);
    }

    var timeoutElLcs = $('#timeout-redirect-lcs');
    if (timeoutElLcs.length) {
        timeoutElLcs.find('span').html(count);
        var interval = setInterval(function () {
            count -= 1;
            if (count > -1) {
                timeoutElLcs.find('span').html(count);
            }
        }, 1000);
        var timeout = setTimeout(function () {
            $('#btn-plugin').trigger('click');
        }, 3000);


        $("#carmen-leasing-calculator").on('click', function () {
            clearInterval(interval);
            clearTimeout(timeout);
        });
    }


};

Eshop.prototype.initCheckInstallment = function () {
    $(".form-check-container-installment").off('click').on('click', function () {

        $('.installment-calc-iplatba').hide();
        $('.installment-calc-lcs').hide();
        $('.installment-calc').hide();

        if ($(this).hasClass('show-installment-calc') && $(this).find('input').is(':checked')) {
            $('.installment-calc').show();
        } else {
            $('.installment-calc').hide();
        }

        if ($(this).hasClass('show-installment-calc-iplatba') && $(this).find('input').is(':checked')) {
            $('.installment-calc-iplatba').show();
        } else {
            $('.installment-calc-iplatba').hide();
        }

        if ($(this).hasClass('show-installment-calc-lcs') && $(this).find('input').is(':checked')) {
            $('.installment-calc-lcs').show();
        } else {
            $('.installment-calc-lcs').hide();
        }
        disabledAnimateAjax = true;
        $.nette.ajax($(this).data('link2'));
    });
};

Eshop.prototype.initRemoveFromGarageBtn = function () {
    $('.removeFromGarage').off('click').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $.nette.ajax($(this).data('remove-from-garage'));
    });
}

Eshop.prototype.initChangeContentSelect = function () {
    $(".initChangeContentSelect").off('change').on('change', function () {
        $('.contentSelect').toggleClass('d-none');
        // $(this).toggleClass("active");
        // var input = $($(this).data("toggle"));
        // if (input.attr("type") == "password") {
        //     input.attr("type", "text");
        // } else {
        //     input.attr("type", "password");
        // }
    });
}

Eshop.prototype.initShowHidePassword = function () {
    $(".toggle-password").click(function () {
        $(this).toggleClass("active");
        var input = $($(this).data("toggle"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
}

Eshop.prototype.stickyCartCarDetail = function () {
    var self = this;

    self.initStickyCartCarDetail();
    $(window).resize(function () {
        var viewportWidth = parseInt($(window).width());
        if (viewportWidth > 767) {
            self.initStickyCartCarDetail();
        } else {
            $(".car-left-content-inner").trigger("sticky_kit:detach");
        }
    });
}

Eshop.prototype.initStickyCartCarDetail = function () {
    $(".stickyCartCarDetail").stick_in_parent({
        parent: ".stickyCartCarDetailWrapper",
    });
    // $(".search.search-form .boxes-toggle").click(function () {
    //     if ($(this).hasClass("active")) {
    //         setTimeout(
    //             function () {
    //                 $(".search.search-form").trigger("sticky_kit:recalc");
    //             }, 1000);
    //     } else {
    //         setTimeout(
    //             function () {
    //                 $(".search.search-form").trigger("sticky_kit:recalc");
    //             }, 1000);
    //     }
    // });
}

Eshop.prototype.initCheckboxShowContent = function () {
    $(".form-check-container-delivery").off('click').on('click', function () {
        $('.form-check-container-delivery-content').hide();
        $('.form-check-container-delivery').removeClass('form-check-container-delivery-show');
        if ($(this).find('input').is(':checked')) {
            $(this).addClass('form-check-container-delivery-show');
        }

        //
        if ($(this).hasClass('form-check-container-delivery-show')) {
            $($(this).data('target')).show();
            disabledAnimateAjax = true;
            $.nette.ajax($(this).data('link'));
        }
    });
}

Eshop.prototype.setAdditionalService = function () {
    $(".setAdditionalService").change(function () {
        var checked = 0;
        if ($(this).find('input').is(':checked')) {
            checked = 1;
        }
        disabledAnimateAjax = true;
        $.nette.ajax($(this).data('link').replace('-checked-', checked));
    });
}